import{a as e}from"./chunk-RAAYCPUM.js";function i(...r){return e(o,r)}function o(r,a){let n=r.findIndex(a);return n===-1?[[...r],[]]:[r.slice(0,n),r.slice(n)]}export{i as a};
